import { CloseIcon } from '../../../assets/icons/Svg'
import useClientAction from '../../../hooks/actions/useClientAction'

export default function ClientDetailsModalHeader() {

    const { handleCloseViewClient } = useClientAction()

    return (
        <div className="flex justify-between items-center py-1">
            <div className="items-start">
                <p className="text-base items-start font-semibold leading-tight text-slate-900">
                    Client Details
                </p>
            </div>
            <div className="flex justify-end items-center">
                <button
                    type="button"
                    className="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 ms-auto inline-flex justify-center items-center"
                    onClick={handleCloseViewClient}
                >
                    <CloseIcon />
                </button>
            </div>
        </div>
    )
}
